/**
 * Validation rules and constraints for form fields
 */

// Cash Flow Discount validation
export const CASH_FLOW_DISCOUNT_MIN = 0.0
export const CASH_FLOW_DISCOUNT_MAX = 1.0
export const CASH_FLOW_DISCOUNT_STEP = 0.01

// Margin of Safety validation
export const MARGIN_OF_SAFETY_MIN = 0.0
export const MARGIN_OF_SAFETY_MAX = 1.0
export const MARGIN_OF_SAFETY_STEP = 0.1

// Number of Years validation
export const NUMBER_OF_YEARS_MIN = 1
export const NUMBER_OF_YEARS_MAX = 100

// Growth Rate validation
export const GROWTH_RATE_MIN = 0.0
export const GROWTH_RATE_MAX = 10.0 // 1000% seems like a reasonable upper bound
export const GROWTH_RATE_STEP = 0.01

// Market Cap to FCF Ratio validation
export const MARKET_CAP_FCF_RATIO_MIN = 0.01
export const MARKET_CAP_FCF_RATIO_MAX = 1000.0
export const MARKET_CAP_FCF_RATIO_STEP = 0.01
